/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MockERC721, MockERC721Interface } from "../MockERC721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "idCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "mintID",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MockERC721__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _name: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockERC721> {
    return super.deploy(_name, overrides || {}) as Promise<MockERC721>;
  }
  getDeployTransaction(
    _name: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, overrides || {});
  }
  attach(address: string): MockERC721 {
    return super.attach(address) as MockERC721;
  }
  connect(signer: Signer): MockERC721__factory {
    return super.connect(signer) as MockERC721__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockERC721Interface {
    return new utils.Interface(_abi) as MockERC721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockERC721 {
    return new Contract(address, _abi, signerOrProvider) as MockERC721;
  }
}
